import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { PropsWithChildren } from "react";
import { MobileNavBar } from "@/components/mobile/NavBar";
import { RegisteredUsersBanner } from "@/components/RegisteredUsersBanner";
import { ErrorBoundaryPage } from "@/components/errors/ErrorBoundaryPage";

export function MainLayout({ children }: PropsWithChildren) {
  return (
    <div className="min-h-screen pb-[73px] lg:pb-0 bg-[#f9fafb] dark:bg-[#020817]">
      <Header />
      <div className="lg:block hidden">
        <RegisteredUsersBanner />
      </div>
      <div>
        <ErrorBoundaryPage>{children}</ErrorBoundaryPage>
      </div>
      <Footer />
      <MobileNavBar />
      {/* <PwaUpdateBanner /> */}
    </div>
  );
}
